import React from "react";
import { Layout } from "antd";

import { StringFormat } from "scripts/helpers";
import Resources from "scripts/resources";

const { Footer } = Layout;

export default () => (
	<Footer>
		<div className="copyright">
			{StringFormat(Resources.copyright, [process.env.REACT_APP_CLIENT])}
		</div>
		<div className="designby">
			<a
				href={process.env.REACT_APP_SITE_URL}
				target="_blank"
				rel="noopener noreferrer"
			>
				{Resources.webDesign}
			</a>
			{` ${Resources.byOwner}`}
		</div>
	</Footer>
);
